// @flow
import { getJson, putJson, postJson, patchJson, del } from 'utils/http';

export type WorkHistoryJob = {
  id: string,
  synonymId: ?string,
  text: string,
  titleSuggestion: ?string,
  title?: {
    selectedId: string,
    selectedText: string,
    standardId: string,
    standardText: string
  },
  orgName: ?string,
  orgId: ?string,
  isCurrent: boolean,
  startDate: ?string | ?number,
  endDate: ?string | ?number,
  positionType: 'JOB' | 'INTERNSHIP' | 'VOLUNTEER',
  isFullTime: boolean,
  managerialStatus: boolean
};

export type Location = { ...SearchLocation, full: string };

export type ApplicantProfile = {
  willingToRelocate: ?boolean,
  prefersRemote: ?boolean,
  openToRemote: ?boolean,
  location: ?Location,
  skills: ?Array<string>,
  workHistoryJobs: Array<WorkHistoryJob>,
  updatedByUser: string
};

type ApplicantProfileResponse = {
  resumeId: ?string,
  isRecruitable: ?boolean,
  applicantProfile: ?ApplicantProfile
};

const emptyProfile = {
  resumeId: null,
  isRecruitable: null,
  workHistoryJobs: []
};

const mapProfileResponse = ({ applicantProfile }) => {
  const { resumeS3FileId: resumeId, isRecruitable, ...profile } =
    applicantProfile || emptyProfile;
  return {
    resumeId,
    isRecruitable,
    applicantProfile: profile
  };
};

export const fetchApplicantProfile = (): Promise<ApplicantProfileResponse> =>
  getJson('/data/userdashboard/applicant-profile/profile').then(
    mapProfileResponse
  );

export const updateApplicantProfile = (
  values: Object
): Promise<ApplicantProfileResponse> =>
  patchJson('/data/userdashboard/applicant-profile/profile', values).then(
    mapProfileResponse
  );

export const addWorkHistoryJob = (
  job: WorkHistoryJob
): Promise<ApplicantProfileResponse> =>
  postJson('/data/userdashboard/applicant-profile/work-history/jobs', job).then(
    mapProfileResponse
  );

export const editWorkHistoryJob = (
  id: string,
  job: WorkHistoryJob
): Promise<ApplicantProfileResponse> =>
  putJson(
    `/data/userdashboard/applicant-profile/work-history/jobs/${id}`,
    job
  ).then(mapProfileResponse);

export const deleteWorkHistoryJob = (
  id: string
): Promise<ApplicantProfileResponse> =>
  del(`/data/userdashboard/applicant-profile/work-history/jobs/${id}`).then(
    mapProfileResponse
  );
